// Tracks whichever content editor currently has focus, so the "insert variable"
// button in the sidebar can splice the token in at the caret position instead of
// always appending it to the end of the content (ET_007).
//
// Two kinds of target, because they take the caret very differently:
//
//   'input'  — a plain <input>/<textarea> (Heading text, Custom HTML code). These
//              expose selectionStart/selectionEnd, and keep them after blur, so the
//              sidebar can slice the string itself.
//   'editor' — a rich-text editor (Quill on the text block). contentEditable has no
//              selectionStart at all, which is why text blocks used to fall through
//              to the append path no matter where the caret was. Those register an
//              `insert` callback instead and do the splice themselves.
let current = null // { blockId, kind, element? , insert? }

export function registerActiveField(element, blockId) {
  current = element ? { blockId, kind: 'input', element } : null
}

export function registerActiveEditor(blockId, insert) {
  current = typeof insert === 'function' ? { blockId, kind: 'editor', insert } : null
}

export function clearActiveField(blockId) {
  if (current?.blockId === blockId) current = null
}

export function getActiveField() {
  return current
}
